﻿<template>
    <attachment
        :attachment="attachment">
        <template #upload-button>
            <div
                v-require-can-edit-tag="tagName"
                class="control horizontal-buttons">
                <b-upload
                    class="file-label"
                    @update:model-value="onUpload">
                    <span class="file-cta">
                        <b-icon
                            class="pr-3"
                            size="is-small"
                            icon="upload" />
                        <span class="file-label">Upload</span>
                    </span>
                </b-upload>
            </div>
        </template>
    </attachment>
</template>

<script>
    import Attachment from '@/shared/components/Attachment.vue';
    import { requireCanEditTag } from '@/shared/directives/requirePermission';
    import { uploadAttachmentToTag } from '@/shared/helpers/api.ts';

    export default {
        directives: {
            requireCanEditTag
        },
        components: {
            Attachment
        },
        props: {
            attachment: {
                type: Object,
                default: () => null
            },
            tagName: {
                type: String,
                required: true
            }
        },
        emits: [
            'updateAttachment'
        ],
        methods: {
            async onUpload(file) {
                const form = new FormData();
                form.append('file', file);
                await uploadAttachmentToTag(this, this.tagName, form);
                this.$emit('updateAttachment');
            }
        }
    };
</script>

<style scoped>
.horizontal-buttons {
    display: inline-block;
}
</style>
